// assets/dynamic-fee.js
// Objectif: Total payé = montant calculé uniquement.
// Méthode: produit principal (12,90€) + REMISE AUTO (-12,90€) => 0,00€,
//          + ligne "Frais de service" à 1,00€ / unité (montant arrondi).
// Barème "sans chute" (non-décroissant). Nettoie ancienne ligne frais liée à CE produit.

(function () {
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const UNIT_FACTOR = 1; // 1 unité = 1 €

  // Barème continu (non-décroissant)
  function computeAmountContinuous(valueRaw) {
    const v = Number(valueRaw || 0);
    if (!Number.isFinite(v) || v < 1) return { amount: 0, rule: '—' };

    let amount = 0; let rule = '';
    if (v <= 50) {
      amount = Math.min(v * 0.50, 25);            // 0..25
      rule = '50% (plafonné à 25 €)';
    } else if (v <= 100) {
      const raw = Math.min(v * 0.25, 25);         // <=25
      amount = Math.max(25, raw);                 // ≥25
      rule = '25% (plafonné à 25 €) — ≥ 25 €';
    } else if (v <= 150) {
      const raw = Math.min(v * 0.20, 30);         // <=30
      amount = Math.max(25, raw);                 // ≥25
      rule = '20% (plafonné à 30 €) — ≥ 25 €';
    } else if (v <= 500) {
      const raw = v * 0.15;                       // 22.65..75
      amount = Math.max(30, raw);                 // ≥30
      rule = '15% — ≥ 30 €';
    } else {
      const raw = v * 0.10;                       // >=50
      amount = Math.max(75, raw);                 // ≥75 (continuité à 500€)
      rule = '10% — ≥ 75 €';
    }
    amount = Math.round(amount * 100) / 100;      // 2 déc.
    return { amount, rule };
  }

  function findProductForm(box) {
    const section = box.closest('section[id^="MainProduct-"], .product, .product__info-wrapper, .product__info-container');
    const scope = section || document;
    const candidates = scope.querySelectorAll('product-form form, form[action*="/cart/add"], form[id*="product"], form[name*="product"]');
    for (const f of candidates) if (f.querySelector('input[name="id"]')) return f;
    return document.querySelector('product-form form, form[action*="/cart/add"]');
  }

  async function addMainProduct(formEl) {
    const fd = new FormData(formEl); // variantes + properties apps (Globo, etc.)
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Ajout produit principal impossible');
  }

  async function removeExistingUnitLine(unitVariantId, productId) {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    for (const it of (cart.items || [])) {
      const isUnit = Number(it.variant_id) === Number(unitVariantId);
      const props = it.properties || {};
      if (isUnit && String(props['DFB Product ID'] || '') === String(productId)) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 0 })
        });
      }
    }
  }

  async function addFeeLine(unitVariantId, productId, cardValue, amountBeforeRound, amountRounded, rule) {
    const payload = {
      items: [{
        id: Number(unitVariantId),
        quantity: Math.round(amountRounded * UNIT_FACTOR), // quantité = euros (arrondi)
        properties: {
          'Valeur de la carte (€)': String(cardValue),
          'Barème': rule + ' (sans chute)',
          'Montant calculé (avant arrondi)': fmt.format(amountBeforeRound),
          'Montant appliqué': fmt.format(amountRounded),
          'DFB Product ID': String(productId),
          'DFB': 'yes'
        }
      }]
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Ajout de la ligne frais impossible');
  }

  function drawerOrRedirect() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const hasDrawer = document.querySelector('cart-drawer, .drawer--cart, cart-notification');
    if (!hasDrawer) window.location.href = '/cart';
  }

  function initBox(box) {
    const pid = box.getAttribute('data-product-id');
    const unitVariantId = Number(box.getAttribute('data-unit-variant-id'));
    const input  = box.querySelector('#dfb-input-' + pid);
    const price  = box.querySelector('#dfb-price-' + pid);
    const ruleEl = box.querySelector('#dfb-rule-' + pid);
    const addBtn = box.querySelector('#dfb-add-' + pid);
    const form   = findProductForm(box);

    if (!unitVariantId || !form || !input || !addBtn || !price || !pid) return;

    const render = () => {
      const { amount, rule } = computeAmountContinuous(input.value);
      const rounded = Math.round(amount * UNIT_FACTOR) / UNIT_FACTOR; // arrondi à l'euro
      price.textContent = fmt.format(rounded);
      if (rule && rule !== '—') { ruleEl.textContent = rule; ruleEl.hidden = false; }
      else { ruleEl.hidden = true; }
    };
    render();
    input.addEventListener('input', render);

    addBtn.addEventListener('click', async () => {
      const cardValue = Number(input.value || 0);
      const { amount, rule } = computeAmountContinuous(cardValue);
      const amountRounded = Math.round(amount * UNIT_FACTOR) / UNIT_FACTOR;

      if (amountRounded <= 0) {
        alert('Merci de saisir une valeur valide (min 1 €).');
        return;
      }

      if (amountRounded >= 500) {
        const ok = confirm(`Vous allez ajouter ${fmt.format(amountRounded)} de frais. Confirmer ?`);
        if (!ok) return;
      }

      addBtn.disabled = true;
      try {
        await addMainProduct(form);                                         // 1) produit principal (sera à 0,00 € via remise auto)
        await removeExistingUnitLine(unitVariantId, pid);                    // 2) purge ancienne ligne frais liée à CE produit
        await addFeeLine(unitVariantId, pid, cardValue, amount, amountRounded, rule); // 3) frais 1€/unité
        drawerOrRedirect();                                                 // 4) refresh / redirection
      } catch (e) {
        console.error(e);
        alert("Impossible d'ajouter au panier. Vérifie les options et réessaie.");
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-dfb]').forEach(initBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
